import Timer from './Timer'

export default Timer
// eslint-disable-next-line import/export
export * from './Timer'
